import { useState } from 'react';
import { IconGlyph } from '../../ui/Primitives.jsx';
import { t } from '../../../i18n/strings.js';

// Tudo fechado por padrão; expansão suave via grid-template-rows (0fr → 1fr).
const FAQ_IDS = [1, 2, 3, 4, 5, 6];

export default function FAQAccordion() {
  const [open, setOpen] = useState(null);
  return (
    <section>
      <h2 className="font-display font-extrabold text-[28px] leading-tight text-center">{t('paywallIntl.faqTitle')}</h2>
      <div className="flex flex-col mt-3 divide-y divide-white/10 border-t border-b border-white/10">
        {FAQ_IDS.map((n, i) => {
          const isOpen = open === i;
          return (
            <div key={n}>
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-3 py-4 text-left"
              >
                <span className="font-display font-bold text-[16px]">{t(`paywallIntl.faq${n}_q`)}</span>
                <IconGlyph
                  name="ti-chevron-down"
                  size={18}
                  className={`shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-cyan' : 'text-ink-muted'}`}
                />
              </button>
              <div
                className="grid transition-[grid-template-rows] duration-300 ease-out"
                style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
              >
                <div className="overflow-hidden">
                  <p className="text-[15px] text-ink-muted pb-4">{t(`paywallIntl.faq${n}_a`)}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
